import { api } from '../utils/libs/axios'
import { ClientAuthDto, LoginDto, NewUserDto } from '../utils/types/auth'

const signup = async (user: NewUserDto) => api.post('/v1/auth/signup', user)

const setSession = async (clientAuth: ClientAuthDto) => api.post(`/v1/auth/set-session`, clientAuth)

const login = async (user: LoginDto) => api.post('/v1/auth/login', user)

const logout = async () => api('/v1/auth/logout')

const recoverAccount = async (email: string) => api.post('/v1/auth/recover-account', { email })

const updatePassword = async (payload: { password: string; clientAuth?: ClientAuthDto }) =>
  api.patch(`/v1/auth/password`, payload)

const deleteAccount = async (id: string) => api.delete(`/v1/auth/${id}`)

export const AuthService = {
  signup,
  setSession,
  login,
  logout,
  recoverAccount,
  updatePassword,
  deleteAccount
}
